export default {
  'menu.workbench': 'workbench',
  'menu.platform-knowledge-graph.dashboard': 'Dashboard',
  'menu.platform-knowledge-graph.ontology': 'Ontology',
  'menu.platform-knowledge-graph.ontology.entity-types': 'Entity Types',
  'menu.platform-knowledge-graph.ontology.relation-types': 'Relation Types',
  'menu.platform-knowledge-graph.ontology.schema-view': 'Schema View',
  'menu.platform-knowledge-graph.entities': 'Entities',
  'menu.platform-knowledge-graph.entities.list': 'All Entities',
  'menu.platform-knowledge-graph.entities.companies': 'Companies',
  'menu.platform-knowledge-graph.entities.persons': 'Persons',
  'menu.platform-knowledge-graph.entities.products': 'Products',
  'menu.platform-knowledge-graph.entities.policies': 'Policies',
  'menu.platform-knowledge-graph.entities.industries': 'Industries',
  'menu.platform-knowledge-graph.entities.technologies': 'Technologies',
  'menu.platform-knowledge-graph.entities.brands': 'Brands',
  'menu.platform-knowledge-graph.entities.regions': 'Regions',
  'menu.platform-knowledge-graph.entities.organizations': 'Organizations',
  'menu.platform-knowledge-graph.entities.standards': 'Standards',
  'menu.platform-knowledge-graph.entities.regulations': 'Regulations',
  'menu.platform-knowledge-graph.entities.events': 'Events',
  'menu.platform-knowledge-graph.entities.websites': 'Websites',
  'menu.platform-knowledge-graph.entities.web-pages': 'Web Pages',
  'menu.platform-knowledge-graph.entities.articles': 'Articles',
  'menu.platform-knowledge-graph.entities.tags': 'Tags',
  'menu.platform-knowledge-graph.entities.concepts': 'Concepts',
  'menu.platform-knowledge-graph.relations': 'Relations',
  'menu.platform-knowledge-graph.graph': 'Graph',
  'menu.platform-knowledge-graph.governance': 'Governance',
  'menu.platform-knowledge-graph.governance.deduplication': 'Deduplication',
  'menu.platform-knowledge-graph.governance.mapping': 'Mapping',
  'menu.platform-knowledge-graph.governance.merge-logs': 'Merge Logs',
  'menu.platform-knowledge-graph.import': 'Import',
  'menu.platform-knowledge-graph.import.data-sources': 'Data Sources',
  'menu.platform-knowledge-graph.import.tasks': 'Import Tasks',
  'menu.platform-knowledge-graph.open-settings': 'Open Settings',
  'menu.platform-knowledge-graph.settings': 'Settings',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'Settings',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
